import {z} from "zod";

const schema = z.object({
	accessToken: z.string(),
	refreshToken: z.string()
});

const model = schema.transform((values) => ({
	...values
}));

export const EmployeeRefreshTokenResModel = {schema, model};
export type IEmployeeRefreshTokenResModel = z.infer<typeof EmployeeRefreshTokenResModel.model>;
export const DEFAULT_EMPLOYEE_REFRESH_TOKEN: IEmployeeRefreshTokenResModel = {
	accessToken: "",
	refreshToken: ""
};
